import { render } from "./ErpAllInOne.vue?vue&type=template&id=310e97c7&scoped=true"
import script from "./ErpAllInOne.vue?vue&type=script&lang=js"
export * from "./ErpAllInOne.vue?vue&type=script&lang=js"

import "./ErpAllInOne.vue?vue&type=style&index=0&id=310e97c7&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310e97c7"]])

export default __exports__